import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { formValueSelector } from "redux-form";
import Form from "../../components/forms/OfficialFormAdding";
import { saveOfficial, withRedirect } from "../../CroActions";
import { isInternal } from "../../CroUtils";
import { convert, addressToForm } from "../../converts";
import { breadcrumbs } from "../../../../actions/appActions";

const postProcess = (data) =>
  convert(data, {
    birthAddress: addressToForm,
    deliveryAddress: addressToForm,
  });
const selector = formValueSelector("officialForm");

const mapStateToProps = (state, { params, auth }) => ({
  loginData: selector(state, "firstName", "lastName", "id"),
  existData: selector(state, "firstName", "lastName", "birthDate"),
  workingPositions: selector(state, "workingPositions") || [],
  statements: [],
  breadcrumbsItems: [{ label: "Funkcionář" }, { label: "Nový funkcionář" }],
  canListStatements: isInternal(auth), //sem legitimate nemuze
  postProcess,
  isNew: true,
  // isArchived: selector(state, 'archived'),
  isMy: selector(state, "isMy"),
  checkedISZR: selector(state, "checkedISZR"),
  deputyOrSenator: selector(state, "deputyOrSenator"),
  canGeneratePassword: true,
  canDisplayCredentials: true,
  previousState: state,
});

const onSubmitWithoutRedirect = (url) => saveOfficial(url);
const onSubmit = (url) => withRedirect(saveOfficial(url), `${url}/funkcionari`);

const mapDispatchToProps = (dispatch, { auth }) => ({
  ...bindActionCreators(
    {
      onSubmit: onSubmit(auth.startUrl),
      onSubmitWithoutRedirect: onSubmitWithoutRedirect(auth.startUrl),
      breadcrumbs },
    dispatch,
  ),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
